// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/img-text/img-text.scss
 ** module id = 168
 ** module chunks = 0 1
 **/